//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_piOverTwo = 1.5707963267948966;\n\
";
